var render = function render(_c,_vm){return _c('span',{staticClass:"tooltip",class:_vm.props.isWide ? 'is-wide': ''},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"tooltip__content"},[_vm._v(_vm._s(_vm.props.tooltip))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }